import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export function getTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_DETAILS.id,
    mainReportId: ReportDefinitions.PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_SUMMARY.id,
    requestParams: {
      impcFrom: rowInfo.row['originImpc'],
      impcTo: rowInfo.row['destinationImpc'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export const destinationImpcProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    className = 'bg-orange-amber';
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn,
    DateColumn,
    NonZeroNumberColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
        new TextColumn('Sending mailbox', 'sendingMailbox'),
        new TextColumn('Receiver', 'receiver'),
        new TextColumn('Receiving mailbox', 'receivingMailbox'),
        new TextColumn('Origin operator', 'originOperator'),
        new TextColumn('Origin IMPC', 'originImpc'),
        new TextColumn('Destination IMPC', 'destinationImpc').withGetProps(destinationImpcProps),
        new DateColumn('Date IMPC closed', 'impcClosedDate'),
        new DateColumn('First observed', 'firstObserved'),
        new NavigationColumn(new NonZeroNumberColumn('Despatches', 'despatches'), getTabNavigationProps),
      ],
    },
  ];
};
